<template>
  <div>
    <transition name="fade">
      <div
        class="popup-modal"
        v-show="show"
        :style="{ display: show ? 'block' : 'none' }"
      >
        <div class="popup-content chat-message-box">
          <div class="flex">
            <div class="menu">
              <img :src="getAvatar(userInfo.avatar)" class="chat-logo" />
              <div
                class="menu-item"
                :class="menu == 'message' ? 'active' : ''"
                @click="changeMenu('message')"
              >
                <img :src="getActiveIcon('message')" class="menu-icon" />
                <div>系统通知</div>
                <div class="badge" v-if="messageNum > 0">
                  {{ messageNum }}
                </div>
              </div>
              <div
                class="menu-item"
                :class="menu == 'user' ? 'active' : ''"
                @click="changeMenu('user')"
              >
                <img :src="getActiveIcon('user')" class="menu-icon" />
                <div>私信</div>
                <div class="badge" v-if="chatNum > 0">{{ chatNum }}</div>
              </div>
              <div
                class="menu-item"
                :class="menu == 'style' ? 'active' : ''"
                @click="changeMenu('style')"
              >
                <img :src="getActiveIcon('style')" class="menu-icon" />
                <div>款式</div>
                <div class="badge" v-if="styleNum > 0">{{ styleNum }}</div>
              </div>
            </div>
            <template v-if="menu == 'message'">
              <div class="message-tabs">
                <div class="search-box">
                  <div class="search-content">
                    <input
                      class="input"
                      size="mini"
                      clearable
                      v-model="keyword"
                      placeholder="请输入内容"
                    />
                    <img
                      src="../assets/images/icon-search.png"
                      style="width: 15px; height: 15px"
                    />
                  </div>
                </div>
                <div
                  class="message-tab"
                  :class="tabIndex == -1 ? 'active' : ''"
                  @click="changeTab(-1)"
                >
                  <img src="../assets/images/message/icon01.png" class="icon" />
                  <span>
                    全部消息
                    <span v-if="messageNum > 0">({{ messageNum }})</span>
                  </span>
                </div>
                <div
                  class="message-tab"
                  style="justify-content: space-between"
                  :class="tabIndex == index ? 'active' : ''"
                  v-for="(item, index) in messageTab"
                  :key="index"
                  @click="changeTab(index)"
                >
                  <div style="display: flex">
                    <img :src="item.icon" class="icon" />
                    <span>{{ item.name }}</span>
                  </div>
                  <div class="badge" v-if="item.count > 0">
                    {{ item.count }}
                  </div>
                </div>
              </div>
              <div class="message-list">
                <div class="top">
                  <div class="left">
                    <span class="title">系统通知</span>
                    <div class="status-tabs">
                      <div
                        class="tab"
                        :class="messageStatus === 0 ? 'active' : ''"
                        @click="messageStatus = 0"
                      >
                        未读
                      </div>
                      <div
                        class="tab"
                        :class="messageStatus === '' ? 'active' : ''"
                        @click="messageStatus = ''"
                      >
                        全部
                      </div>
                    </div>
                  </div>
                  <button class="set-all-read" @click="setAllRead()">
                    全部设为已读
                  </button>

                  <img
                    src="../assets/images/icon-close-chat.png"
                    class="close"
                    @click="close_modal"
                  />
                </div>
                <div class="messgae-content" ref="messageContent" @scroll="handleScroll">
                  <div
                    class="message-item"
                    v-for="(item, index) in messageList"
                    :key="index"
                    @click="goDetail(item)"
                  >
                    <img
                      src="../assets/images/message/icon05.png"
                      class="icon"
                    />
                    <div style="margin-left: 10px; flex: 1">
                      <div class="title-box">
                        <div>
                          <span class="title"
                            >【{{ item.message_type_name }}】{{
                              item.title
                            }}</span
                          >
                          <span class="time">{{ item.create_time }}</span>
                        </div>
                      </div>
                      <div class="content-box">
                        <div class="content">{{ item.content }}</div>
                        <div class="view" v-if="item.show_detail">
                          查看详情>
                        </div>
                      </div>
                    </div>
                    <div class="action">
                      <div
                        class="read"
                        v-if="item.is_read == 0"
                        @click.stop="setRead(index)"
                      >
                        已读
                      </div>
                      <div class="delete" @click.stop="deleteMessage(index)">
                        删除
                      </div>
                    </div>
                    <div class="red-dot" v-if="item.is_read == 0"></div>
                  </div>
                  <div class="message-loading" v-if="pageLoading">加载中...</div>
                  <div class="message-loading" v-else-if="messageList.length > 0 && pageFinished">没有更多了</div>
                </div>
              </div>
            </template>

            <template v-if="menu == 'user'">
              <div class="user-list">
                <div class="search-box">
                  <div class="search-content">
                    <input
                      class="input"
                      size="mini"
                      clearable
                      v-model="keyword"
                      placeholder="请输入内容"
                    />
                    <img
                      src="../assets/images/icon-search.png"
                      style="width: 15px; height: 15px"
                    />
                  </div>
                </div>
                <div
                  class="user-item"
                  :class="[index == currentUserIndex ? 'active' : '', { 'new-service': item.is_new_service }]"
                  v-for="(item, index) in userList"
                  :key="index"
                  @click="chooseUser(index)"
                >
                  <img
                    :src="item.avatar"
                    style="width: 40px; height: 40px; border-radius: 50%"
                  />
                  <div class="margin-left-10 align-center" style="width: 80%">
                    <div class="over-hidden" style="color: #333">
                      {{ item.nickname }}
    
                    </div>
                    <div
                      class="text-12 margin-top-10 text-999"
                      v-if="item.last_message"
                    >
                      {{ item.last_message.time }}
                    </div>
                 
                  </div>
                  <div v-if="item.num > 0" class="badge">{{ item.num }}</div>
                </div>
              </div>
            </template>
            <template v-if="menu == 'style'">
              <div class="user-list">
                <template>
                  <div
                    class="user-item"
                    style="
                      background: #fff;
                      font-weight: bold;
                      color: #1a1a1a;
                      font-size: 16px;
                    "
                  >
                    款式咨询
                  </div>
                  <div
                    class="user-item"
                    style="
                      justify-content: center;
                      color: #ccc;
                      font-size: 13px;
                    "
                    v-if="styleList.length == 0"
                  >
                    —— 暂无款式 ——
                  </div>
                </template>
                <div
                  class="user-item"
                  :class="index == currentStyleIndex ? 'active' : ''"
                  v-for="(item, index) in styleList"
                  :key="index"
                  @click="chooseStyle(index)"
                >
                  <img
                    :src="getStyleImg(item.image)"
                    style="width: 40px; height: 40px; border-radius: 50%"
                  />
                  <div class="margin-left-10 align-center" style="width: 80%">
                    <div class="over-hidden" style="color: #333">
                      款式：{{ item.style_name }}
                    </div>
                    <div
                      class="text-12 margin-top-10 text-999"
                      v-if="item.last_message"
                    >
                      {{ item.last_message.time }}
                    </div>
                  </div>
                  <div v-if="item.num > 0" class="badge">{{ item.num }}</div>
                </div>
              </div>
            </template>
            <template v-if="menu == 'user' || menu == 'style'">
              <div
                class="chat-list"
                @drop.prevent="handleDrop"
                @dragover.prevent="onDragOver"
              >
                <!-- 客服系统嵌入 - 仅新客服或后台客服私聊时启用 -->
                <!-- 已回归站内 IM：私信/款式会话统一使用站内聊天，不再嵌入第三方客服 -->
                <template>
                  <div class="flex align-center justify-between chat-title" >
                  <div class="flex align-center">
                    <span v-if="currenUser && menu == 'style' && currenUser.to_user_role == 'employee'">在线客服</span>
                    <span v-else-if="currenUser">{{ currenUser.nickname }}</span>
                    <span v-if="currentStyle && menu == 'style'"
                      >（{{ currentStyle.style_name }}）</span
                    >
                    <template
                      v-if="currenUser && currenUser.to_user_role == 'employee'"
                    >
                      <div
                        style="font-size: 12px; color: #999; margin-left: 20px"
                        class="flex align-center"
                        v-if="isOnlineByTime"
                      >
                        <span>[ </span>
                        <img
                          src="../assets/images/chat/online.png"
                          style="width: 17px; height: 17px"
                        />
                        <span> 在线 ]</span>
                      </div>
                      <div
                        style="font-size: 12px; color: #999; margin-left: 20px"
                        class="flex align-center"
                        v-if="!isOnlineByTime"
                      >
                        <span>[ </span>
                        <img
                          src="../assets/images/chat/offline.png"
                          style="width: 17px; height: 17px"
                        />
                        <span> 离线中 ]</span>
                      </div>
                      <div
                        style="font-size: 12px; color: #999; margin-left: 10px"
                        v-if="!isOnlineByTime"
                      >
                        <span
                          >服务时间：{{ setting.service_time_start }} -
                          {{ setting.service_time_end }}</span
                        >
                      </div>
                    </template>
                  </div>

                  <img
                    src="../assets/images/icon-close-chat.png"
                    style="width: 24px; height: 24px; cursor: pointer"
                    @click="close_modal"
                  />
                </div>
                <div
                  ref="chatcontent"
                  class="chat-content"
                  id="chat-content"
                  :style="{ height: chatContentHeight + 'px' }"
                  @scroll="onChatScroll"
                >
                  <div v-for="(item, index) in chat_list" :key="index">
                    <div
                      v-if="item.recall == 1"
                      class="flex align-center justify-center"
                    >
                      <span v-if="item.creator_id == userInfo.id"
                        >你撤回了一条消息</span
                      >
                      <span v-if="item.creator_id != userInfo.id"
                        >对方撤回了一条消息</span
                      >

                      <span
                        v-if="item.canEditReCall && item.message_type == 'text'"
                        style="color: #0077dd"
                        @click="editReCall(item)"
                        >重新編輯</span
                      >
                    </div>
                    <template v-if="item.recall == 0">
                      <div
                        style="
                          text-align: right;
                          padding-bottom: 5px;
                          font-size: 12px;
                        "
                        v-if="item.creator_id == userInfo.id"
                      >
                        {{ item.create_time }}
                      </div>
                      <div
                        style="
                          text-align: left;
                          padding-bottom: 5px;
                          font-size: 12px;
                        "
                        v-if="item.creator_id != userInfo.id"
                      >
                        {{ item.create_time }}
                      </div>
                      <div
                        class="chat-item"
                        :class="
                          item.creator_id == userInfo.id
                            ? 'chat-item-right'
                            : 'chat-item-left'
                        "
                      >
                        <template v-if="item.creator_id == userInfo.id">
                          <div
                            class="chat-item-action"
                            style="margin-right: 5px"
                          >
                            <div class="is_read" v-if="item.is_other_read == 1">
                              已读
                            </div>
                            <div
                              class="is_no_read"
                              v-if="item.is_other_read == 0"
                            >
                              未读
                            </div>
                            <Poptip
                              trigger="hover"
                              placement="left"
                              width="100"
                            >
                              <template #content>
                                <div class="action-item-box">
                                  <div
                                    class="action-item"
                                    @click="copyContent(item)"
                                    v-if="item.message_type == 'text'"
                                  >
                                    复制
                                  </div>
                                  <div
                                    class="action-item"
                                    @click="reCallChat(item)"
                                  >
                                    撤回
                                  </div>
                                  <div
                                    class="action-item"
                                    @click="quoteChat(item)"
                                  >
                                    引用
                                  </div>
                                </div>
                              </template>
                              <img
                                src="../assets/images/icon-more.png"
                                style="
                                  width: 24px;
                                  height: 24px;
                                  cursor: pointer;
                                "
                              />
                            </Poptip>
                          </div>

                          <div class="message-box">
                            <!--引用开始-->
                            <div
                              v-if="item.quote"
                              class="quote-message-box"
                              @click="showQuoteModal(item.chat_uuid)"
                            >
                              <div
                                style="
                                  color: #999999;
                                  font-size: 14px;
                                  font-weight: bold;
                                "
                                v-if="item.quote.creator_type == 'employee'"
                              >
                                衣创社区在线客服
                              </div>
                              <div
                                style="
                                  color: #999999;
                                  font-size: 14px;
                                  font-weight: bold;
                                "
                                v-if="item.quote.creator_type == 'user'"
                              >
                                {{ item.quote.creator_name }}
                              </div>

                              <template
                                v-if="item.quote.message_type == 'text'"
                              >
                                <div class="message">
                                  {{ item.quote.message }}
                                </div>
                              </template>
                              <template
                                v-if="
                                  item.quote.message_type == 'file' ||
                                  item.quote.message_type == 'img'
                                "
                              >
                                <div class="file-box">
                                  <a
                                    v-for="(file, i) in item.quote.message_file"
                                    :key="i"
                                    :href="file.url"
                                    target="_blank"
                                  >
                                    <div
                                      class="file-name"
                                      v-if="file.type == 'file'"
                                    >
                                      {{ file.name }}
                                    </div>
                                    <img
                                      :src="file.url"
                                      v-if="file.type == 'img'"
                                      class="file-img"
                                    />
                                  </a>
                                </div>
                              </template>
                              <template
                                v-if="item.quote.message_type == 'design'"
                              >
                                <div
                                  class="design_info"
                                  @click="goDesign(item.quote.design_info.uuid)"
                                >
                                  <div class="left">
                                    <img
                                      :src="
                                        item.quote.design_info.image
                                          | default_img
                                      "
                                      alt=""
                                      class="image"
                                    />
                                  </div>
                                  <div class="right">
                                    <div class="name-wrap">
                                      <div class="name">
                                        {{ item.quote.design_info.name }}
                                      </div>
                                    </div>
                                    <div class="style_no">
                                      <span>款号</span>
                                      ：{{ item.quote.design_info.style_no }}
                                    </div>
                                    <div class="category">
                                      <span>款式分类</span>
                                      ：{{
                                        item.quote.design_info
                                          .product_category_name
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </template>
                              <template
                                v-if="item.quote.message_type == 'order'"
                              >
                                <div
                                  class="design_info"
                                  @click="
                                    goOrder(item.quote.order_info.order_id)
                                  "
                                >
                                  <div class="left">
                                    <img
                                      :src="
                                        item.quote.order_info.style_img
                                          | default_img
                                      "
                                      alt=""
                                      class="image"
                                    />
                                  </div>
                                  <div class="right">
                                    <div class="name-wrap">
                                      <div class="name">
                                        订单号:{{
                                          item.quote.order_info.order_no
                                        }}
                                      </div>
                                    </div>
                                    <div class="style_no">
                                      <span>款式</span>
                                      ：{{ item.quote.order_info.style_name }}
                                    </div>
                                    <div class="category">
                                      <span>款式分类</span>
                                      ：{{
                                        item.quote.order_info
                                          .product_category_name
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </template>
                              <template
                                v-if="
                                  item.quote.message_type == 'fabric' ||
                                  item.quote.message_type == 'accessory'
                                "
                              >
                                <div
                                  class="fabric_accessory_info"
                                  @click="
                                    goFabricAccessory(
                                      item.quote.fabric_accessory.id,
                                      item.quote.message_type
                                    )
                                  "
                                >
                                  <img
                                    :src="
                                      item.quote.fabric_accessory.image
                                        | default_img
                                    "
                                    alt=""
                                    class="image"
                                  />

                                  <div class="name">
                                    {{ item.quote.fabric_accessory.name }}
                                  </div>
                                </div>
                              </template>
                            </div>
                            <!--引用结束-->
                            <template v-if="item.message_type == 'text'">
                              <div class="message">{{ item.message }}</div>
                            </template>
                            <template
                              v-if="
                                item.message_type == 'file' ||
                                item.message_type == 'img'
                              "
                            >
                              <div class="file-box">
                                <a
                                  v-for="(file, i) in item.message_file"
                                  :key="i"
                                  :href="file.url"
                                  target="_blank"
                                >
                                  <div
                                    class="file-name"
                                    v-if="file.type == 'file'"
                                  >
                                    {{ file.name }}
                                  </div>
                                  <img
                                    :src="file.url"
                                    v-if="file.type == 'img'"
                                    class="file-img"
                                  />
                                </a>
                              </div>
                            </template>
                            <template v-if="item.message_type == 'voice'">
                              <div
                                class="voice-msg-box"
                                :style="{ width: voiceBubbleWidth(item) }"
                                @click="handleVoicePlay(item)"
                              >
                                <img
                                  v-if="voicePlayingId !== item.chat_uuid"
                                  src="https://img.hongli.xingjuju.com/yichuanghub/default/20260803/58a782d00f174ab0ba7b915854c3b743.png"
                                  class="voice-play-icon"
                                />
                                <span v-else class="voice-playing-tip">播放中…</span>
                                <span class="voice-duration">{{ voiceDurationText(item) }}</span>
                              </div>
                            </template>
                            <template v-if="item.message_type == 'design'">
                              <div
                                class="design_info"
                                @click="goDesign(item.design_info.uuid)"
                              >
                                <div class="left">
                                  <img
                                    :src="getStyleImg(item.design_info.image)"
                                    alt=""
                                    class="image"
                                  />
                                </div>
                                <div class="right">
                                  <div class="name-wrap">
                                    <div class="name">
                                      {{ item.design_info.name }}
                                    </div>
                                  </div>
                                  <div class="style_no">
                                    <span>款号</span>
                                    ：{{ item.design_info.style_no }}
                                  </div>
                                  <div class="category">
                                    <span>款式分类</span>
                                    ：{{
                                      item.design_info.product_category_name
                                    }}
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-if="item.message_type == 'order'">
                              <div
                                class="design_info"
                                @click="goOrder(item.order_info.uuid)"
                              >
                                <div class="left">
                                  <img
                                    :src="
                                      getStyleImg(item.order_info.style_img)
                                    "
                                    alt=""
                                    class="image"
                                  />
                                </div>
                                <div class="right">
                                  <div class="name-wrap">
                                    <div class="name">
                                      订单号:{{ item.order_info.order_no }}
                                    </div>
                                  </div>
                                  <div class="style_no">
                                    <span>款式</span>
                                    ：{{ item.order_info.style_name }}
                                  </div>
                                  <div class="category">
                                    <span>款式分类</span>
                                    ：{{
                                      item.order_info.product_category_name
                                    }}
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template
                              v-if="
                                item.message_type == 'fabric' ||
                                item.message_type == 'accessory'
                              "
                            >
                              <div
                                class="fabric_accessory_info"
                                @click="
                                  goFabricAccessory(item.fabric_accessory.id,item.message_type)
                                  
                                "
                              >
                                <img
                                  :src="
                                    item.fabric_accessory.image | default_img
                                  "
                                  alt=""
                                  class="image"
                                />
                                <div class="name">
                                  {{ item.fabric_accessory.name }}
                                </div>
                              </div>
                            </template>
                          </div>
                          <img
                            :src="getAvatar(item.creator_avatar)"
                            class="avatar"
                          />
                        </template>
                        <template v-if="item.creator_id != userInfo.id">
                          <img
                            :src="getAdminAvatar(item.creator_avatar)"
                            class="avatar"
                            v-if="item.creator_type == 'employee'"
                          />
                          <img
                            :src="getAvatar(item.creator_avatar)"
                            class="avatar"
                            v-if="item.creator_type == 'user'"
                          />
                          <div class="message-box">
                            <!--引用开始-->
                            <div
                              v-if="item.quote"
                              class="quote-message-box"
                              @click="showQuoteModal(item.chat_uuid)"
                            >
                              <div
                                style="
                                  color: #999999;
                                  font-size: 14px;
                                  font-weight: bold;
                                "
                                v-if="item.quote.creator_type == 'employee'"
                              >
                                衣创社区在线客服
                              </div>
                              <div
                                style="
                                  color: #999999;
                                  font-size: 14px;
                                  font-weight: bold;
                                "
                                v-if="item.quote.creator_type == 'user'"
                              >
                                {{ item.quote.creator_name }}
                              </div>

                              <template
                                v-if="item.quote.message_type == 'text'"
                              >
                                <div class="message">
                                  {{ item.quote.message }}
                                </div>
                              </template>
                              <template
                                v-if="
                                  item.quote.message_type == 'file' ||
                                  item.quote.message_type == 'img'
                                "
                              >
                                <div class="file-box">
                                  <a
                                    v-for="(file, i) in item.quote.message_file"
                                    :key="i"
                                    :href="file.url"
                                    target="_blank"
                                  >
                                    <div
                                      class="file-name"
                                      v-if="file.type == 'file'"
                                    >
                                      {{ file.name }}
                                    </div>
                                    <img
                                      :src="file.url"
                                      v-if="file.type == 'img'"
                                      class="file-img"
                                    />
                                  </a>
                                </div>
                              </template>
                              <template
                                v-if="item.quote.message_type == 'design'"
                              >
                                <div
                                  class="design_info"
                                  @click="goDesign(item.quote.design_info.uuid)"
                                >
                                  <div class="left">
                                    <img
                                      :src="
                                        item.quote.design_info.image
                                          | default_img
                                      "
                                      alt=""
                                      class="image"
                                    />
                                  </div>
                                  <div class="right">
                                    <div class="name-wrap">
                                      <div class="name">
                                        {{ item.quote.design_info.name }}
                                      </div>
                                    </div>
                                    <div class="style_no">
                                      <span>款号</span>
                                      ：{{ item.quote.design_info.style_no }}
                                    </div>
                                    <div class="category">
                                      <span>款式分类</span>
                                      ：{{
                                        item.quote.design_info
                                          .product_category_name
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </template>
                              <template
                                v-if="item.quote.message_type == 'order'"
                              >
                                <div
                                  class="design_info"
                                  @click="
                                    goOrder(item.quote.order_info.order_id)
                                  "
                                >
                                  <div class="left">
                                    <img
                                      :src="
                                        item.quote.order_info.style_img
                                          | default_img
                                      "
                                      alt=""
                                      class="image"
                                    />
                                  </div>
                                  <div class="right">
                                    <div class="name-wrap">
                                      <div class="name">
                                        订单号:{{
                                          item.quote.order_info.order_no
                                        }}
                                      </div>
                                    </div>
                                    <div class="style_no">
                                      <span>款式</span>
                                      ：{{ item.quote.order_info.style_name }}
                                    </div>
                                    <div class="category">
                                      <span>款式分类</span>
                                      ：{{
                                        item.quote.order_info
                                          .product_category_name
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </template>
                              <template
                                v-if="
                                  item.quote.message_type == 'fabric' ||
                                  item.quote.message_type == 'accessory'
                                "
                              >
                                <div
                                  class="fabric_accessory_info"
                                  @click="
                                    goFabricAccessory(
                                      item.quote.fabric_accessory.id,
                                      item.quote.message_type
                                    )
                                  "
                                >
                                  <img
                                    :src="
                                      item.quote.fabric_accessory.image
                                        | default_img
                                    "
                                    alt=""
                                    class="image"
                                  />

                                  <div class="name">
                                    {{ item.quote.fabric_accessory.name }}
                                  </div>
                                </div>
                              </template>
                            </div>
                            <!--引用结束-->
                            <template v-if="item.message_type == 'text'">
                              <div class="message">{{ item.message }}</div>
                            </template>
                            <template
                              v-if="
                                item.message_type == 'file' ||
                                item.message_type == 'img'
                              "
                            >
                              <div class="file-box">
                                <a
                                  v-for="(file, i) in item.message_file"
                                  :key="i"
                                  :href="file.url"
                                  target="_blank"
                                >
                                  <div
                                    class="file-name"
                                    v-if="file.type == 'file'"
                                  >
                                    {{ file.name }}
                                  </div>
                                  <img
                                    :src="file.url"
                                    v-if="file.type == 'img'"
                                    class="file-img"
                                  />
                                </a>
                              </div>
                            </template>
                            <template v-if="item.message_type == 'voice'">
                              <div
                                class="voice-msg-box"
                                :style="{ width: voiceBubbleWidth(item) }"
                                @click="handleVoicePlay(item)"
                              >
                                <img
                                  v-if="voicePlayingId !== item.chat_uuid"
                                  src="https://img.hongli.xingjuju.com/yichuanghub/default/20260803/58a782d00f174ab0ba7b915854c3b743.png"
                                  class="voice-play-icon"
                                />
                                <span v-else class="voice-playing-tip">播放中…</span>
                                <span class="voice-duration">{{ voiceDurationText(item) }}</span>
                              </div>
                            </template>
                            <template v-if="item.message_type == 'design'">
                              <div
                                class="design_info"
                                @click="goDesign(item.design_info.uuid)"
                              >
                                <div class="left">
                                  <img
                                    :src="getStyleImg(item.design_info.image)"
                                    alt=""
                                    class="image"
                                  />
                                </div>
                                <div class="right">
                                  <div class="name-wrap">
                                    <div class="name">
                                      {{ item.design_info.name }}
                                    </div>
                                  </div>
                                  <div class="style_no">
                                    <span>款号</span>
                                    ：{{ item.design_info.style_no }}
                                  </div>
                                  <div class="category">
                                    <span>款式分类</span>
                                    ：{{
                                      item.design_info.product_category_name
                                    }}
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-if="item.message_type == 'order'">
                              <div
                                class="design_info"
                                @click="goOrder(item.order_info.uuid)"
                              >
                                <div class="left">
                                  <img
                                    :src="
                                      getStyleImg(item.order_info.style_img)
                                    "
                                    alt=""
                                    class="image"
                                  />
                                </div>
                                <div class="right">
                                  <div class="name-wrap">
                                    <div class="name">
                                      订单号:{{ item.order_info.order_no }}
                                    </div>
                                  </div>
                                  <div class="style_no">
                                    <span>款式</span>
                                    ：{{ item.order_info.style_name }}
                                  </div>
                                  <div class="category">
                                    <span>款式分类</span>
                                    ：{{
                                      item.order_info.product_category_name
                                    }}
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template
                                v-if="
                                  item.message_type == 'fabric' ||
                                  item.message_type == 'accessory'
                                "
                              >
                                <div
                                  class="fabric_accessory_info"
                                  @click="
                                    goFabricAccessory(
                                      item.fabric_accessory.id,
                                      item.message_type
                                    )
                                  "
                                >
                                  <img
                                    :src="
                                      item.fabric_accessory.image
                                        | default_img
                                    "
                                    alt=""
                                    class="image"
                                  />

                                  <div class="name">
                                    {{ item.fabric_accessory.name }}
                                  </div>
                                </div>
                              </template>
                          </div>
                          <div
                            class="chat-item-action"
                            style="margin-left: 5px"
                          >
                            <Poptip
                              trigger="hover"
                              placement="right"
                              width="100"
                            >
                              <template #content>
                                <div class="action-item-box">
                                  <div
                                    class="action-item"
                                    @click="copyContent(item)"
                                    v-if="item.message_type == 'text'"
                                  >
                                    复制
                                  </div>
                                  <div
                                    class="action-item"
                                    @click="quoteChat(item)"
                                  >
                                    引用
                                  </div>
                                </div>
                              </template>
                              <img
                                src="../assets/images/icon-more.png"
                                style="
                                  width: 24px;
                                  height: 24px;
                                  cursor: pointer;
                                "
                              />
                            </Poptip>
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
                <div
                  class="resizer"
                  :class="{ resizing: isResizing }"
                  @mousedown="initDrag"
                >
                  <div class="resizer-dot"></div>
                </div>
                <div
                  class="submit-box"
                  :style="{ height: submitBoxHeight + 'px' }"
                >
                  <div class="flex align-center" v-if="!isChatDisabled">
                    <emoji-picker @emoji="append">
                      <button
                        id="emojiBtn"
                        class="icon-emoji"
                        slot="emoji-invoker"
                        slot-scope="{ events: { click: clickEvent } }"
                        @click.stop="
                          ($event) => {
                            clickEvent($event);
                            show_emoji = !show_emoji;
                          }
                        "
                      ></button>
                      <div
                        slot="emoji-picker"
                        slot-scope="{ emojis, insert, display }"
                      >
                        <div class="emoji-picker">
                          <div>
                            <div
                              v-for="(emojiGroup, category) in emojis"
                              :key="category"
                            >
                              <h5>{{ category }}</h5>
                              <div class="emojis">
                                <span
                                  v-for="(emoji, emojiName) in emojiGroup"
                                  :key="emojiName"
                                  @click.stop="insert(emoji)"
                                  :title="emojiName"
                                >
                                  {{ emoji }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </emoji-picker>
                    <Upload
                      action=""
                      style="margin-left: 10px"
                      multiple
                      :show-upload-list="false"
                      :before-upload="(file) => beforeUpload(file, 'img')"
                      accept=".jpg,.jpeg,.png,.gif"
                      :format="['jpg', 'jpeg', 'png', 'gif']"
                    >
                      <a title="发送图片">
                        <img
                          src="../assets/images/chat/chat-image.png"
                          style="width: 23px; height: 23px"
                        />
                      </a>
                    </Upload>

                    <Upload
                      action=""
                      style="margin-left: 10px"
                      :show-upload-list="false"
                      :before-upload="(file) => beforeUpload(file, 'file')"
                    >
                      <a title="发送文件">
                        <img
                          src="../assets/images/chat/chat-file.png"
                          style="width: 23px; height: 23px"
                        />
                      </a>
                    </Upload>
                    <template v-if="currenUser && currenUser.to_user_id == 1">
                      <a title="发送订单" style="margin-left: 10px">
                        <img
                          src="../assets/images/chat/chat-order.png"
                          style="width: 23px; height: 23px"
                          @click="$refs.selectOrder.show()"
                        />
                      </a>
                      <a
                        title="发送款式"
                        style="margin-left: 10px"
                        @click="$refs.selectDesign.show()"
                      >
                        <img
                          src="../assets/images/chat/chat-style.png"
                          style="width: 23px; height: 23px"
                        />
                      </a>
                      <a
                        title="发送面料"
                        style="margin-left: 10px"
                        @click="$refs.selectFabricAccessory.show('fabric')"
                      >
                        <img
                          src="../assets/images/chat/chat-fabric.png"
                          style="width: 23px; height: 23px"
                        />
                      </a>
                      <a
                        title="发送辅料"
                        style="margin-left: 10px"
                        @click="$refs.selectFabricAccessory.show('accessory')"
                      >
                        <img
                          src="../assets/images/chat/chat-accessory.png"
                          style="width: 23px; height: 23px"
                        />
                      </a>
                    </template>
                  </div>
                  <div class="quote-box flex justify-between" v-if="quoteItem">
                    <div class="flex">
                      <span v-if="quoteItem.creator_type == 'employee'"
                        >衣创社区在线客服:</span
                      >
                      <span v-if="quoteItem.creator_type == 'user'"
                        >{{ quoteItem.creator_name }}:</span
                      >

                      <div v-if="quoteItem.message_type == 'text'">
                        {{ quoteItem.message }}
                      </div>
                      <div v-if="quoteItem.message_type == 'design'">
                        [款式]
                      </div>
                      <div v-if="quoteItem.message_type == 'order'">[订单]</div>
                      <div v-if="quoteItem.message_type == 'fabric'">
                        [面料]
                      </div>
                      <div v-if="quoteItem.message_type == 'accessory'">
                        [辅料]
                      </div>

                      <div
                        class="file-box"
                        v-if="
                          quoteItem.message_type == 'file' ||
                          quoteItem.message_type == 'img'
                        "
                      >
                        <label
                          v-for="(file, i) in quoteItem.message_file"
                          :key="i"
                        >
                          <a
                            class="uk-margin-small-right"
                            :href="file.url"
                            v-if="file.type == 'img'"
                            target="_blank"
                          >
                            <img style="width: 20px" :src="file.url" />
                          </a>
                          <a
                            :href="file.message_file"
                            v-if="file.type == 'file'"
                            target="_blank"
                          >
                            <div class="name">{{ file.name }}</div>
                          </a>
                        </label>
                      </div>
                    </div>
                    <span class="cursor" @click="deleteQuote()">x</span>
                  </div>
                  <div class="chat-input" v-if="currenUser">
                    <textarea
                      class="chat-input-textarea"
                      :class="{ disabled: isChatDisabled }"
                      @keyup.enter="submitEnter"
                      @keyup.ctrl.enter="handleCtrlEnterKey"
                      v-model="currenUser.content"
                      @paste="handlePaste"
                      :disabled="isChatDisabled"
                      :placeholder="isChatDisabled ? '历史消息仅查看，如需咨询请联系在线客服' : '请输入，按Enter直接发送消息，Ctrl+Enter换行'"
                    ></textarea>
                  </div>

                  <button 
                    class="submit" 
                   
                    @click="isChatDisabled ? openCustomerService() : submit()"
                  >{{ isChatDisabled ? '立即咨询' : '发送' }}</button>
                </div>
                </template>
                
              </div>
            </template>
          </div>
        </div>
      </div>
    </transition>
    <ArticleDetail
      ref="articleDetail"
      v-if="show_detail"
      @on-close="show_detail = false"
      :uuid="uuid"
    ></ArticleDetail>
    <SelectDesign
      ref="selectDesign"
      @select-design="selectDesignBack"
    ></SelectDesign>
    <SelectOrder
      ref="selectOrder"
      @select-order="selectOrderBack"
    ></SelectOrder>
    <SelectFabricAccessory
      ref="selectFabricAccessory"
      @select-fabric="selectFabricAccessoryBack"
    ></SelectFabricAccessory>
    <FabricAccessoryShow
      ref="fabricAccessoryShow"
    ></FabricAccessoryShow>
    <AppealReviewStatusModal
      ref="appealReviewStatusModal"
      :visible.sync="showAppealStatusModal"
      :appeal_id="appeal_id"
    ></AppealReviewStatusModal>

    <ChatQuote ref="chatQuote"></ChatQuote>
  </div>
</template>

<script>
import OSS from "ali-oss";
import { EmojiPicker } from "vue-emoji-picker";
import { mapState, mapGetters } from "vuex";
import request from "@/utils/chat.js";
import {
  GetChatList,
  addMessage,
  GetChatUser,
  GetChatStyle,
  GetMessageList,
  GetMessageCount,
  SetMessageRead,
  SetAllMessageRead,
  DeleteMessage,
  GetUserList,
  SetOtherRead,
  FileDownAndToOssAPi,
  SetRecall,
  HasChatMessage
} from "@/api/chat.js";

import ArticleDetail from "@/components/ArticleDetail";
import SelectDesign from "@/components/SelectDesign";
import SelectOrder from "@/components/SelectOrder";
import SelectFabricAccessory from "@/components/SelectFabricAccessory";
import FabricAccessoryShow from "@/components/FabricAccessoryShow";
import AppealReviewStatusModal from "@/views/Shop/Manage/components/shopCommentManage/components/appealReviewStatusModal.vue";

import ChatQuote from "@/components/ChatQuote";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);
import { uploadFileToOSS } from "@/utils/oss";


export default {
  name: "Chat",
  props: {
    mask: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show: false,
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      menu: "user",
      keyword: "",
      styleList: [],
      currentStyleIndex: 0,
      chat_list: [],
      content: "",
      chat_page: 1,
      chat_page_size: 30,
      chat_finished: false,
      chat_loading: false,

      messageTab: [
        {
          name: "站内通知",
          message_type: 1,
          message_name: "internal",
          icon: require("@/assets/images/message/icon02.png"),
          count: 0,
        },
        // {
        //   name:'权益发放',
        //   message_type:2,
        //   message_name:'right',
        //   icon:require("@/assets/images/message/icon03.png")
        // },
        //  {
        //   name:'其他通知',
        //   message_type:3,
        //   message_name:'other',
        //   icon:require("@/assets/images/message/icon04.png")
        // }
      ],
      currentUserIndex: 0,
      userList: [],
      tabIndex: -1,
      messageList: [],
      page: 1,
      total: 0,
      pageLoading: false,
      pageFinished: false,
      messageStatus: 0,
      messageCount: {
        all: 0,
        internal: 0,
        right: 0,
        other: 0,
      },
      show_detail: false,
      uuid: "",
      showAppealStatusModal: false,
      appeal_id: 0,
      show_emoji: false,
      quoteItem: null,
      startHeight: 0,
      submitBoxHeight: 150,
      chatContentHeight: 535,
      // 拖动状态
      isResizing: false,
      // 保存初始拖动位置
      startY: 0,
      // 容器总高度
      containerHeight: 685,
      hasChatMessage:false,
      order_no:'',
      style_img:'',
      style_number:'',
      kefuConfig:null,
      voicePlayingId:'',
      // 面辅料咨询：会话初始化完成后待发送的面辅料消息
      pending_fabric_message: null
    };
  },
  components: {
    ArticleDetail,
    EmojiPicker,
    SelectDesign,
    SelectOrder,
    ChatQuote,
    SelectFabricAccessory,
    FabricAccessoryShow,
    AppealReviewStatusModal
  },

  computed: {
    ...mapState({
      message: (state) => state.scoket.message,
      userInfo: (state) => state.userInfo,
      chatNum: (state) => state.scoket.chatNum,
      styleNum: (state) => state.scoket.styleNum,
      messageNum: (state) => state.scoket.messageNum,
      chat_uuids: (state) => state.scoket.chat_uuids,
      re_call_chat_uuid: (state) => state.scoket.re_call_chat_uuid,
      setting: (state) => state.setting,
      is_login: (state) => state.is_login,
    }),
    currenUser() {
      if (this.userList.length > 0) {
        return this.userList[this.currentUserIndex];
      } else {
        return null;
      }
    },
    currentStyle() {
      if (this.styleList.length > 0) {
        return this.styleList[this.currentStyleIndex];
      } else {
        return null;
      }
    },
    isOnlineByTime() {
      if (
        !this.setting ||
        !this.setting.service_time_start ||
        !this.setting.service_time_end
      ) {
        return false;
      }
      const date = dayjs().format("YYYY-MM-DD");
      let startTime = date + " " + this.setting.service_time_start;
      let endTime = date + " " + this.setting.service_time_end;
      const now = dayjs();
      return now.isBetween(startTime, endTime);
    },
    // 已回归站内 IM：官方客服(to_user_id==1)会话为普通站内聊天，不禁发、不引导第三方客服
    isChatDisabled() {
      return false;
    },
  },
  watch: {
    messageStatus: function (newVal, oldVal) {
      this.getMessageList(1, true);
    },
    tabIndex: function (newVal, oldVal) {
      this.getMessageList(1, true);
    },
    message: {
      handler(newValue, oldValue) {
        if (newValue != oldValue && newValue) {
          this.pushMessage(JSON.parse(newValue));
        }
      },
      deep: true,
    },
    chat_uuids: {
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.setChatIsRead(JSON.parse(newValue));
        }
      },
      deep: true,
    },
    re_call_chat_uuid: {
      handler(newValue, oldValue) {
        if (newValue != oldValue && newValue) {
          this.backMessage(newValue);
        }
      },
      deep: true,
    },
    show: {
      handler(newValue, oldValue) {
        if (!newValue) {
          this.$store.commit("scoket/setChatShow", false);
          this.$store.dispatch("scoket/getMessage");
        }
      },
    },
    is_login: {
      handler(newValue, oldValue) {
        if (newValue) {
         this.getHasMessage()
        }
      },
    },
  },
  mounted() {
    this.getHasMessage();
  },
  beforeDestroy() {
    this.stopVoicePlay();
  },

  methods: {
    async getHasMessage() {
      console.error(this.is_login,"123")
      if(this.is_login){
        let { data } = await HasChatMessage()
        this.hasChatMessage = data.has_message
      }
    },
    initDrag(e) {
      this.isResizing = true;
      this.startY = e.clientY; // 鼠标按下时的Y坐标
      this.startHeight = this.submitBoxHeight;
      document.addEventListener("mousemove", this.doDrag); // 监听鼠标移动事件
      document.addEventListener("mouseup", this.stopDrag); // 监听鼠标松开事件
      e.preventDefault();
    },

    doDrag(e) {
      if (this.isResizing) {
        // 计算高度变化
        const deltaY = this.startY - e.clientY;
        let newHeight = this.startHeight + deltaY;
        // 限制最小和最大高度
        const minSubmitHeight = 150;
        const maxSubmitHeight = 300;

        // 应用限制
        if (newHeight < minSubmitHeight) newHeight = minSubmitHeight;
        if (newHeight > maxSubmitHeight) newHeight = maxSubmitHeight;

        // 更新高度
        this.submitBoxHeight = newHeight;
        this.chatContentHeight = this.containerHeight - newHeight;
      }
    },
    stopDrag() {
      this.isResizing = false; // 停止拖动状态
      document.removeEventListener("mousemove", this.doDrag); // 移除鼠标移动事件监听器
      document.removeEventListener("mouseup", this.stopDrag); // 移除鼠标松开事件监听器
    },
    showEmoji() {
      console.log("this.show_emoji", this.show_emoji);
      if (this.show_emoji) {
        document.getElementById("emojiBtn").click();
      }
    },
    clickEvent(e) {
      console.log("clickEvent", e);
      this.show_emoji = !this.show_emoji;
    },
    append(emoji) {
      console.log("emoji", emoji);
      this.currenUser.content += emoji;
    },
    // ===== 语音消息：展示与播放 =====
    _normVoiceDuration(duration) {
      if (!duration || duration <= 0) return 0;
      // 超过 100 判定为毫秒，转成秒
      return duration > 100 ? duration / 1000 : duration;
    },
    voiceDurationText(item) {
      const file = item && item.message_file && item.message_file[0];
      let d = this._normVoiceDuration(file ? file.duration : 0);
      if (!d || d <= 0) return '0"';
      if (d < 60) return Math.round(d) + '"';
      const minutes = Math.floor(d / 60);
      const remaining = Math.round(d % 60);
      return minutes + "'" + remaining.toString().padStart(2, "0") + '"';
    },
    voiceBubbleWidth(item) {
      const file = item && item.message_file && item.message_file[0];
      let d = this._normVoiceDuration(file ? file.duration : 0);
      const s = d > 0 ? d : 1;
      const w = Math.min(220, Math.max(120, 120 + Math.min(s, 60) * (100 / 60)));
      return Math.round(w) + "px";
    },
    stopVoicePlay() {
      this.voicePlayingId = "";
      if (this._voiceAudio) {
        try {
          this._voiceAudio.pause();
          this._voiceAudio.onended = null;
          this._voiceAudio.onerror = null;
          this._voiceAudio.src = "";
        } catch (e) {}
        this._voiceAudio = null;
      }
    },
    handleVoicePlay(item) {
      if (!item || item.message_type !== "voice" || !item.message_file || !item.message_file[0] || !item.message_file[0].url) {
        return;
      }
      const url = item.message_file[0].url;
      // 点击当前正在播放的 -> 停止
      if (this.voicePlayingId === item.chat_uuid) {
        this.stopVoicePlay();
        return;
      }
      this.stopVoicePlay();
      const audio = new Audio(url);
      this._voiceAudio = audio;
      this.voicePlayingId = item.chat_uuid;
      audio.onended = () => {
        this.stopVoicePlay();
      };
      audio.onerror = () => {
        this.stopVoicePlay();
        this.$Message && this.$Message.error("语音播放失败");
      };
      audio.play().catch(() => {
        this.stopVoicePlay();
      });
    },
    changeTab(index) {
      this.tabIndex = index;
    },
    async getMessageCount() {
      let { data } = await GetMessageCount();
      this.messageCount = data;
      this.messageTab.forEach((i) => {
        i.count = data[i.message_name];
      });
      this.$forceUpdate();
    },
    async getMessageList(page = 1, reset = false) {
      if (this.pageLoading) {
        return;
      }
      // 加载更多时，没有更多数据则停止
      if (!reset && this.pageFinished) {
        return;
      }
      this.pageLoading = true;
      let param = {
        page: page,
        limit: 10,
      };
      if (this.messageStatus !== "") {
        param.is_read = this.messageStatus;
      }
      if (this.tabIndex >= 0) {
        param.message_type = this.messageTab[this.tabIndex].message_type;
      }
      let { data } = await GetMessageList(param);
      this.pageLoading = false;
      this.page = page;
      this.total = data.total || 0;
      const list = data.list || [];
      // 判断是否还有下一页
      this.pageFinished = this.page * 10 >= this.total;
      this.messageList = reset ? list : this.messageList.concat(list);
    },
    goDetail(item) {
      if (!item.show_detail) {
        return;
      }
      if (item.type == 10) {
        // 评价申诉结果：打开申诉审核状态弹窗，状态由弹窗内部从详情接口读取
        this.appeal_id = item.source_id;
        this.showAppealStatusModal = true;
        return;
      }
      if ([1, 2].indexOf(item.type) >= 0) {
        this.show = false;
        this.$router.push({
          path: "/workbench/creations",
        });
      }
      if ([3, 4, 5, 6].indexOf(item.type) >= 0) {
        if (item.type == 5 || item.type == 6) {
          this.uuid = item.comment.post.uuid;
        } else {
          this.uuid = item.post.uuid;
        }
        this.show_detail = true;
      }
    },
    setAllRead() {
      let list = this.messageList.filter((i) => {
        return i.is_read == 0;
      });
      if (list.length == 0) {
        return;
      }
      SetAllMessageRead().then(() => {
        this.messageList.forEach((i) => {
          i.is_read = 1;
        });
        // 后端将当前用户全部消息设为已读，同步刷新侧边栏计数
        this.messageTab.forEach((t) => {
          t.count = 0;
        });
        this.messageCount.all = 0;
        this.messageCount.internal = 0;
        this.messageCount.right = 0;
        this.messageCount.other = 0;
        this.$forceUpdate();
      });
    },
    loadMore() {
      if (this.pageLoading || this.pageFinished) {
        return;
      }
      this.getMessageList(this.page + 1, false);
    },
    handleScroll() {
      const el = this.$refs.messageContent;
      if (!el) {
        return;
      }
      // 滚动到接近底部时加载下一页
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50) {
        this.loadMore();
      }
    },
    // 未读消息数量减1（按消息所属分类）
    decreaseUnreadCount(item) {
      if (this.tabIndex >= 0) {
        const tab = this.messageTab[this.tabIndex];
        if (tab.count > 0) {
          tab.count--;
        }
      } else {
        // 全部 tab：所有分类的未读数都减1
        this.messageTab.forEach((t) => {
          if (t.count > 0) {
            t.count--;
          }
        });
      }
      // 顶部全部未读数也减1
      if (this.messageCount.all > 0) {
        this.messageCount.all--;
      }
      // 对应分类的 count 也减1
      if (item.message_name && this.messageCount[item.message_name] > 0) {
        this.messageCount[item.message_name]--;
      }
    },
    setRead(index) {
      SetMessageRead({
        id: this.messageList[index].id,
      }).then(() => {
        const item = this.messageList[index];
        if (item.is_read == 0) {
          item.is_read = 1;
          this.decreaseUnreadCount(item);
        }
        this.$forceUpdate();
      });
    },
    deleteMessage(index) {
      const item = this.messageList[index];
      DeleteMessage({
        id: item.id,
      }).then(() => {
        // 删除的是未读消息，则未读数量减1
        if (item.is_read == 0) {
          this.decreaseUnreadCount(item);
        }
        this.messageList.splice(index, 1);
        this.total = Math.max(0, this.total - 1);
        // 删除后重新计算是否还有下一页
        this.pageFinished = this.page * 10 >= this.total;
        this.$forceUpdate();
      });
    },
    changeMenu(menu) {
      if (this.menu == menu) {
        return;
      }
      this.menu = menu;
      if (menu == "user") {
        this.getUserList();
      }
      if (menu == "style") {
        this.getStyleList();
      }
    },
    close_modal() {
      this.show = false;
      this.$store.commit("scoket/setChatShow", false);
    },
    showChat(design = null, user = null) {
      this.$store.commit("scoket/setChatShow", true);
      // 款式咨询：从款式/订单等携带 design 场景进入款式会话（回归站内原行为）
      if (design) {
        this.menu = "style";
      }
      this.chat_list = [];
      this.getUserList(design, user);
      this.getStyleList(design);
      this.page = 1;
      this.total = 0;
      this.pageFinished = false;
      this.getMessageList(1, true);
      this.getMessageCount();
      this.show = true;
    },
    /**
     * 面辅料咨询：打开客服会话并自动发送一条面辅料图文消息
     * 消息以 fabric_accessory 卡片形式发送，后台技术客服点击可打开详情查看
     * @param {Object} payload - { type: 'fabric'|'accessory', id, name, image }
     */
    showChatWithFabricAccessory(payload = {}) {
      if (!payload || !payload.id) {
        // 缺少可打开的面辅料 id 时，退化为仅打开客服会话
        return this.showChat();
      }
      const type = payload.type === "accessory" ? "accessory" : "fabric";
      // 面辅料咨询统一进入官方客服会话
      this.menu = "user";
      this.pending_fabric_message = {
        message: "",
        message_type: type,
        message_file: [],
        fabric_accessory: {
          name: payload.name || "",
          type,
          image: payload.image || "",
          id: payload.id,
        },
      };
      this.showChat();
    },
    // 会话（用户列表 + 聊天记录）初始化完成后，发送待发送的面辅料消息
    flushPendingFabricMessage() {
      if (!this.pending_fabric_message) {
        return;
      }
      if (!this.currenUser || !this.currenUser.to_user_id) {
        return;
      }
      const chat = this.pending_fabric_message;
      this.pending_fabric_message = null;
      this.addMessage(chat);
    },

    //切换会员
    chooseUser(index) {
      // this.userList[index].num = 0
      if (this.currentUserIndex == index) {
        return;
      }
      this.currentUserIndex = index;
      this.getChatList();
    },
    //切换款式
    chooseStyle(index) {
      // this.styleList[index].num = 0
      if (this.currentStyleIndex == index) {
        return;
      }
      this.currentStyleIndex = index;

      this.getStyleChatList();
    },
    async getUserList(design = null, chatUser = null) {
      let { data } = await GetUserList();
      // 过滤掉 users 中只有自己一个人的脏数据（群组成员不完整）
      data = data.filter((i) => {
        return i.users.some((ii) => ii.user_id != i.user_id);
      });
      data.forEach((i) => {
        let item = i.users.find((ii) => {
          return ii.user_id != i.user_id;
        });
        if (item.user_role == "user") {
          i.nickname = item.user.nickname || item.user.realname;
          i.avatar = this.getAvatar(item.user.avatar);
        } else {
          i.nickname = "衣创社区在线客服";
          i.avatar = this.getAdminAvatar(item.employee.avatar);
        }
        i.to_user_role = item.user_role;
        i.to_user_id = item.user_id;
      });

      // 确保“官方客服”(to_user_id==1) 会话可用，缺失时补充站内占位会话
      const ensureAdmin = () => {
        let idx = data.findIndex((i) => i.to_user_id == 1);
        if (idx == -1) {
          data.unshift({
            avatar: require("@/assets/images/chat/chat-logo.png"),
            nickname: "衣创社区在线客服",
            to_user_id: 1,
            num: 0,
            to_user_role: "employee",
          });
          return 0;
        }
        return idx;
      };
      // 从款式/订单那边过来：款式会话另行处理，这里落到官方客服
      if (design) {
        this.currentUserIndex = ensureAdmin();
      } else if (chatUser) {
        // 和别的用户私聊
        let idx = data.findIndex((i) => i.to_user_id == chatUser.id);
        if (idx != -1) {
          this.currentUserIndex = idx;
        } else {
          // 用户不存在，先添加到列表
          data.unshift({
            avatar: chatUser.avatar,
            nickname: chatUser.nickname || chatUser.realname,
            to_user_id: chatUser.id,
            num: 0,
            to_user_role: "user",
          });
          this.currentUserIndex = 0;
        }
      } else {
        // 默认进入官方客服（站内 IM）
        this.currentUserIndex = ensureAdmin();
      }

      // 已回归站内 IM：不再添加第三方“在线客服”假入口
      
      // 根据message设置选中状态（消息推送场景）
      if (this.message) {
        let message = JSON.parse(this.message);
        console.log(message, "message");
        this.currentUserIndex = data.findIndex(
          (i) => i.to_user_id == message.creator_id
        );
        this.$store.commit("scoket/setMessageNull");
      }
      
      // 已回归站内 IM：默认选中逻辑已由上方各分支决定，不再清合力访客未读

      this.userList = data;
      if (this.menu == "user") {
        await this.getChatList();
      }
      this.flushPendingFabricMessage();
    },
    async getStyleList(design = null) {
      let { data } = await GetChatStyle();
      //从款式那边过来
      if (design) {
        let style = data.find((i) => i.uuid == design.uuid);
        if (style) {
          this.currentStyleIndex = data.findIndex((i) => i.uuid == design.uuid);
        } else {
          data.unshift({
            style_name: design.name,
            image: design.image,
            uuid: design.uuid,
            from: design.from,
          });
          this.currentStyleIndex = 0;
          this.chat_list = [];
        }
      }
      this.styleList = data;
      if (this.menu == "style") {
        this.getStyleChatList();
      }
    },
    async getChatList() {
      let uuid = 0;

      // 切换会话时从第一页开始，重置分页状态
      this.chat_page = 1;
      this.chat_finished = false;
      let param = {
        to_user_id: this.currenUser.to_user_id,
        page: this.chat_page,
        page_size: this.chat_page_size,
      };
      let { data } = await GetChatList(param);
      let other_read_list = data.filter((i) => {
        return i.is_other_read == 0 && i.creator_id != this.userInfo.id;
      });
      if (other_read_list.length > 0) {
        let ids = other_read_list.map((i) => i.chat_uuid);
        this.handleOtherRead(other_read_list[0], ids);
      }
      let is_no_read_list = data.filter((i) => {
        return i.is_read == 0;
      });
      if (this.menu == "user") {
        console.log(this.userList);
        console.log(this.currenUser);
        this.currenUser.num = 0;
        this.$store.commit("scoket/setChatNumReduce", is_no_read_list.length);
      }

      this.chat_list = data;
      this.chat_finished = data.length < this.chat_page_size;
      this.toScrollBottom();
    },
    async getStyleChatList() {
      if (this.styleList.length == 0) {
        this.chat_list = [];
        return;
      }
      let uuid = 0;
      // 切换会话时从第一页开始，重置分页状态
      this.chat_page = 1;
      this.chat_finished = false;
      let param = {
        to_user_id: 1,
        page: this.chat_page,
        page_size: this.chat_page_size,
      };
      param.uuid = this.styleList[this.currentStyleIndex].uuid;
      param.from = this.styleList[this.currentStyleIndex].from;
      let { data } = await GetChatList(param);

      let other_read_list = data.filter((i) => {
        return i.is_other_read == 0 && i.creator_id != this.userInfo.id;
      });
      if (other_read_list.length > 0) {
        let ids = other_read_list.map((i) => i.chat_uuid);
        this.handleOtherRead(other_read_list[0], ids);
      }

      this.chat_list = data;
      this.chat_finished = data.length < this.chat_page_size;
      let is_no_read_list = data.filter((i) => {
        return i.is_read == 0;
      });
      if (this.menu == "style") {
        this.styleList[this.currentStyleIndex].num = 0;
        this.$store.commit("scoket/setStyleNumReduce", is_no_read_list.length);
      }
      this.toScrollBottom();
    },
    // 滚动到顶部时加载更早的历史消息
    async loadMoreChat() {
      if (this.chat_finished || this.chat_loading) {
        return;
      }
      let param = {
        to_user_id: 1,
        page: this.chat_page + 1,
        page_size: this.chat_page_size,
      };
      if (this.menu == "user") {
        if (!this.currenUser) return;
        param.to_user_id = this.currenUser.to_user_id;
      } else if (this.menu == "style") {
        if (!this.styleList.length) return;
        param.uuid = this.styleList[this.currentStyleIndex].uuid;
        param.from = this.styleList[this.currentStyleIndex].from;
      } else {
        return;
      }
      this.chat_loading = true;
      let { data } = await GetChatList(param);
      this.chat_loading = false;
      if (!data.length) {
        this.chat_finished = true;
        return;
      }
      const el = this.$refs.chatcontent;
      const oldScrollHeight = el ? el.scrollHeight : 0;
      this.chat_list = [...data, ...this.chat_list];
      this.chat_page += 1;
      this.chat_finished = data.length < this.chat_page_size;
      this.$nextTick(() => {
        if (el) {
          el.scrollTop = el.scrollHeight - oldScrollHeight;
        }
      });
    },
    onChatScroll(e) {
      if (e.target.scrollTop < 30) {
        this.loadMoreChat();
      }
    },

    sendMessage(url, data) {
      request.post(url, data);
    },
    //撤回通知
    backMessage(chat_uuid) {
      let item = this.chat_list.find((i) => {
        return i.chat_uuid == chat_uuid;
      });
      if (item) {
        this.$set(item, "recall", 1);
      }
    },
    setChatIsRead(chat_uuids) {
      chat_uuids.forEach((chat_uuid) => {
        let item = this.chat_list.find((i) => {
          return i.chat_uuid == chat_uuid;
        });
        if (item) {
          this.$set(item, "is_other_read", 1);
        }
      });
      this.$forceUpdate();
    },
    pushMessage(data) {
      if (!this.show) {
        return false;
      }
      console.error(data, "pushMessage");
      if (this.menu == "user" && data.uuid == 0) {
        let userIndex = this.userList.findIndex((i) => {
          return i.group_id == data.group_id;
        });
        if (userIndex == this.currentUserIndex) {
          this.chat_list.push(data);
          //接收到消息设置已读
          if (this.show) {
            this.handleOtherRead(data, [data.chat_uuid]);
          }
          this.toScrollBottom();
        } else {
          this.userList[userIndex].num++;
          let userItem = this.userList[userIndex];
          this.userList.splice(userIndex, 1);
          this.userList.unshift(userItem);
          if (this.currentUserIndex < userIndex) {
            this.currentUserIndex++;
          }
        }
      }

      if (this.menu == "style" && data.uuid) {
        let style = this.styleList.find((i) => {
          return i.uuid == data.uuid;
        });

        if (style) {
          let styleIndex = this.styleList.findIndex((i) => {
            return i.uuid == data.uuid;
          });
          if (styleIndex == this.currentStyleIndex) {
            this.chat_list.push(data);
            if (this.show) {
              this.handleOtherRead(data, [data.chat_uuid]);
            }
            this.toScrollBottom();
          } else {
            this.styleList[styleIndex].num++;
          }
        } else {
          if (this.currentStyleIndex == 0 && !data.uuid) {
            this.chat_list.push(data);
            this.toScrollBottom();
          } else {
            this.styleList.push({
              group_id: data.group_id,
              uuid: data.uuid,
              num: 1,
              style_name: data.style_name,
              image: data.image,
              from: data.from,
              last_message: {
                message: data.message,
              },
            });
          }
        }
      }
      this.$store.commit("scoket/setMessageNull");
    },
    handleOtherRead(data, chat_uuids) {
      var sendMsg = {
        type: "other_read",
        to_uid: data.creator_id + "_" + data.creator_type,
        chat_uuids,
      };
      SetOtherRead({
        chat_uuids,
      });
      this.sendMessage("send_other_read", sendMsg);
    },
    handlePaste(event) {
      let clipdata = event.clipboardData || window.clipboardData;
      if (!clipdata) {
        return this.$layer.msg("当前浏览器不支持");
      }
      let length = clipdata.items.length;
      for (let i = 0; i < clipdata.items.length; i++) {
        let item = clipdata.items[i];
        let blob;
        //获取内容
        blob = item.getAsFile();
        console.log(blob);
        if (item.type == "text/plain") {
          return;
        }
        let fileType = this.isImg(blob.name) ? "img" : "file";
        uploadFileToOSS(blob, "template").then((url) => {
          this.addMessage({
            message: "",
            message_type: fileType,
            message_file: [
              {
                type: fileType,
                url: url,
                name: blob.name,
              },
            ],
          });
        });
      }
    },
    onDragOver(event) {
      event.preventDefault(); //阻止浏览器默认行为
    },
    handleDrop(event) {
      console.error(123);
      const files = event.target.files || event.dataTransfer.files;
      Array.from(files).forEach(async (file) => {
        let file_type = this.isImg(file.name) ? "img" : "file";
        // 处理文件，例如上传到服务器
        console.log(file); // 在这里你可以调用上传函数或进行其他处理
        const url = await uploadFileToOSS(file, "template");
        this.addMessage({
          message: "",
          message_type: file_type,
          message_file: [
            {
              type: file_type,
              url: url,
              name: file.name,
            },
          ],
        });
      });
    },
    isImg(fileName) {
      const imageExtensions = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "webp",
        "avif",
      ];
      const fileExtension = fileName.split(".").pop().toLowerCase();
      return imageExtensions.includes(fileExtension);
    },
    handleCtrlEnterKey(e) {
      this.currenUser.content = this.currenUser.content + "\n";
    },
    submitEnter(e) {
       console.log(123434)
      if (e.ctrlKey && !this.currenUser.content) {
        return;
      }
      this.submit();
    },
    submit() {
      if (
        !this.currenUser.content ||
        (this.currenUser.content &&
          !this.currenUser.content.trim())
      ) {
        console.log(123434)
        return false;
      }
      this.addMessage({
        message: this.currenUser.content,
        message_type: "text",
        message_file: [],
      });
      this.currenUser.content = "";
    },
    // 打开新客服系统
    openCustomerService() {
      // 切换到私聊菜单
      this.menu = 'user';
      // 切换到新客服系统（位于用户列表第一个位置）
      this.currentUserIndex = 0;
      this.getChatList();
    },
    getStyleImg(img) {
      return img || require("@/assets/images/default.jpg");
    },
    getAvatar(creator_avatar) {
      if (creator_avatar) {
        return creator_avatar;
      }
      if (this.userInfo.avatar) {
        return this.userInfo.avatar;
      }
      if (this.userInfo.sex == 1) {
        var defaultavatar = require("@/assets/images/chat/avatar-man.png");
      } else {
        var defaultavatar = require("@/assets/images/chat/avatar-women.png");
      }
      return defaultavatar;
    },
    getAdminAvatar(creator_avatar) {
      return creator_avatar || require("@/assets/images/chat/chat-logo.png");
    },

    getActiveIcon(menu) {
      if (menu == "user") {
        if (this.menu == "user") {
          return require("@/assets/images/chat/chat-icon-active.png");
        } else {
          return require("@/assets/images/chat/chat-icon.png");
        }
      }
      if (menu == "style") {
        if (this.menu == "style") {
          return require("@/assets/images/chat/style-icon-active.png");
        } else {
          return require("@/assets/images/chat/style-icon.png");
        }
      }
      if (menu == "message") {
        if (this.menu == "message") {
          return require("@/assets/images/chat/message-icon-active.png");
        } else {
          return require("@/assets/images/chat/message-icon.png");
        }
      }
    },
    beforeUpload(file, file_type) {
      this.uploadSectionFile(file, file_type);
      return false;
    },
    async uploadSectionFile(file, file_type) {
      const url = await uploadFileToOSS(file, "template");
      let message_file = [];
      message_file.push({
        type: file_type,
        url: url,
        name: file.name,
      });
      this.addMessage({
        message: "",
        message_type: file_type,
        message_file: message_file,
      });
    },

    async addMessage(chat) {
      if (this.quoteItem) {
        chat.quote = {
          creator_id: this.quoteItem.creator_id,
          creator_name: this.quoteItem.creator_name,
          creator_type: this.quoteItem.creator_type,
          message: this.quoteItem.message,
          message_translate: this.quoteItem.message_translate,
          message_file: this.quoteItem.message_file,
          message_type: this.quoteItem.message_type,
          design_info: this.quoteItem.design_info,
          order_info: this.quoteItem.order_info,
          fabric_accessory: this.quoteItem.fabric_accessory,
          original_chat_uuid: this.quoteItem.original_chat_uuid,
        };
      }
      if (this.menu == "user") {
        if (this.currenUser.group_id) {
          chat.group_id = this.currenUser.group_id;
        }
        chat.uuid = 0;
        chat.to_user_id = this.currenUser.to_user_id;
        chat.user_type = this.currenUser.to_user_role;

        let { data } = await addMessage(chat);
        this.quoteItem = null;
        var sendMsg = {
          type: "send",
          to_uid: this.currenUser.to_user_id + "_" + this.currenUser.to_user_role,
          message: data,
        };
        if (!this.currenUser.group_id) {
          this.currenUser.group_id = data.group_id;
        }
        this.sendMessage("send_message", sendMsg);
        this.chat_list.push(data);
        this.toScrollBottom();
      }

      if (this.menu == "style") {
        if (this.styleList.length == 0) {
          return this.$layer.msg("暂无款式");
        }
        chat.uuid = this.currentStyle.uuid;
        chat.from = this.currentStyle.from;

        if (this.currenUser.group_id) {
          chat.group_id = this.currenUser.group_id;
        }
        chat.to_user_id = 1; //默认管理员1
        chat.user_type = "employee";
        let { data } = await addMessage(chat);
        this.quoteItem = null;
        data.image = this.currentStyle.image;

        var sendMsg = {
          type: "send",
          to_uid: chat.to_user_id + "_" + chat.user_type,
          message: data,
        };
        if (!this.currenUser.group_id) {
          this.currenUser.group_id = data.group_id;
        }
        this.sendMessage("send_message", sendMsg);
        this.chat_list.push(data);
        this.toScrollBottom();
      }
    },

    toScrollBottom() {
      let that = this;
      setTimeout(() => {
        let main = that.$refs.chatcontent;
        main.scrollTop = main.scrollHeight;
      }, 200);
    },
    selectDesignBack(list) {
      list.forEach((item) => {
        this.addMessage({
          message: "",
          message_type: "design",
          message_file: [],
          design_info: {
            image: item.image,
            name: item.name,
            style_no: item.style_no,
            uuid: item.uuid,
            id: item.id,
            product_category_name: item.product_category_name,
            factory_price: item.factory_price,
          },
        });
      });
    },
    selectOrderBack(list) {
      list.forEach((item) => {
        this.addMessage({
          message: "",
          message_type: "order",
          message_file: [],
          order_info: {
            order_no: item.order_no,
            style_img: item.style_img,
            style_name: item.style_name,
            uuid: item.uuid,
            order_id: item.order_id,
            product_category_name: item.design.product_category_name,
          },
        });
      });
    },
    selectFabricAccessoryBack(data) {
      console.log(data.list, data.type);

      data.list.forEach((item) => {
        this.addMessage({
          message: "",
          message_type: data.type,
          message_file: [],
          fabric_accessory: {
            name:
              data.type == "fabric" ? item.fabric_name_cn : item.accessory_name,
            type: data.type,
            image: item.image,
            id: item.id,
          },
        });
      });
    },

    goOrder(uuid) {
      const uri = `${window.location.origin}/order/detail?uuid=${uuid}`;
      console.log("uri", uri);
      window.open(uri, "_blank");
    },
    goDesign(uuid) {
      const uri = `${window.location.origin}/workbench/design?uuid=${uuid}`;
      window.open(uri, "_blank");
    },
    goFabricAccessory(id,type) {
      if (!id) {
        this.$layer.msg("面辅料信息不存在");
        return;
      }
      this.$refs.fabricAccessoryShow.show(id,type)
    },
    copyContent(item) {
      navigator.clipboard.writeText(item.message).then(() => {
        this.$layer.msg("复制成功");
      });
    },
    reCallChat(item) {
      console.log(item,'123')
      SetRecall({
        chat_uuid: item.chat_uuid,
      })
        .then((res) => {
          var sendMsg = {
            type: "reCall",
            to_uid: this.currenUser.to_user_id + "_" + this.currenUser.to_user_role,
            chat_uuid: item.chat_uuid,
          };
          this.sendMessage("back_message", sendMsg);
          this.$set(item, "recall", 1);
          this.$set(item, "canEditReCall", true);
        })
        .catch((e) => {
          this.$layer.msg(e.msg);
        });
    },
    editReCall(item) {
      this.currenUser.content = item.message;
    },
    quoteChat(item) {
      this.quoteItem = item;
    },
    deleteQuote() {
      this.quoteItem = null;
    },
    showQuoteModal(chat_uuid) {
      this.$refs.chatQuote.show(chat_uuid);
    },
    // 获取客服系统嵌入URL
    getCustomerServiceUrl() {
      // URL由后端拼接返回，前端直接使用，敏感参数不暴露
      if (this.kefuConfig && this.kefuConfig.url) {
        return this.kefuConfig.url;
      }
      // 兜底：接口未返回时使用默认地址（无敏感参数）
      return '';
    },
  },
  created() {},
};
</script>

<style scoped lang="scss">
.popup-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 199;
  overflow: auto;
  background: rgba(0, 0, 0, 0.6);

  .popup-content {
    position: relative;
    background: white;
    margin: 0 auto;
    border-radius: 10px;
    z-index: 199;
    height: 800px;
    width: 892px;
    top: 50px;

    .icon-close {
      position: absolute;
      width: 18px;
      height: 18px;
      top: 25px;
      right: 25px;
      cursor: pointer;
    }
  }
}
::v-deep .ivu-poptip-popper {
  min-width: 100px !important;
  .ivu-poptip-content {
    border-radius: 10px !important;
  }
  .ivu-poptip-inner {
    border-radius: 10px !important;
  }
  // .ivu-poptip-arrow{
  // 	display:none !important;
  // }
  .ivu-poptip-body {
    padding: 0px !important;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px #b3b3b3;
    border-radius: 10px !important;
  }
}

.flex {
  display: flex;
}

.flex-sub {
  flex: 1;
}

.justify-between {
  justify-content: space-between;
}

.align-center {
  align-items: center;
}

.text-12 {
  font-size: 12px;
}

.text-999 {
  color: #999;
}

.text-green {
  color: #20c997;
}

.margin-top-10 {
  margin-top: 10px;
}

.margin-left-10 {
  margin-left: 10px;
}

.new-service-tag {
  display: inline-block;
  font-size: 10px;
  color: #fff;
  background-color: #20c997;
  padding: 1px 4px;
  border-radius: 3px;
  margin-left: 5px;
  vertical-align: middle;
}

.user-item.new-service {
  background: linear-gradient(90deg, #f0fff4 0%, #fff 100%);
  border-left: 3px solid #20c997;
}

.chat-input-textarea.disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}

.submit.disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
/* 客服系统嵌入样式 */
.customer-service-embed {
  width: 627px;
  background: #f5f5f5;
  height: 800px;
  position: relative;
  .close{
    position: absolute;
    top: 10px;
    right:10px;
    width: 30px; 
    height: 30px;
    cursor: pointer;
  }
}

.cs-iframe {
  width: 100%;
  height: 800px;
  min-height: 80px;
}

.over-hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menu {
  width: 65px;
  height: 800px;
  background: #22252c;
  border-radius: 10px 0px 0px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .chat-logo {
    width: 38px;
    height: 38px;
    margin: 20px auto;
    border-radius: 50%;
  }

  .menu-item {
    width: 56px;
    height: 60px;
    border-radius: 8px 8px 8px 8px;
    position: relative;
    text-align: center;
    color: #ffffff;
    font-size: 12px;
    margin-bottom: 10px;

    .message-box-num {
      top: 0px;
      position: absolute;
      right: 0px;
    }

    .menu-icon {
      width: 28px;
      height: 28px;
      margin-top: 8px;
    }

    &.active {
      background: #393b42;
    }

    .badge {
      background-color: #f34d37;
      border-radius: 10px;
      color: #fff;
      display: inline-block;
      font-size: 12px;
      height: 18px;
      line-height: 18px;
      padding: 0 6px;
      text-align: center;
      white-space: nowrap;
      border: 1px solid #fff;
      position: absolute;
      top: -5px;
      right: -5px;
    }
  }
}

.user-list::-webkit-scrollbar {
  display: none;
}

.user-list {
  width: 200px;
  height: 800px;
  background: #ebe9e7;
  overflow-y: scroll;
  overflow-x: hidden;

  .search-box {
    width: 200px;
    height: 60px;
    padding: 13px 15px;
    border-bottom: 1px solid #e1e2e6;

    .search-content {
      width: 180px;
      height: 35px;
      background: #fafafa;
      border-radius: 20px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      position: sticky;
      top: 10px;
      left: 0px;
      z-index: 1;

      .input {
        border: none;
        background: #fafafa;
        outline: none;
        width: 80%;
      }
    }
  }

  .user-item {
    position: relative;
    display: flex;
    align-items: center;
    height: 66px;
    padding: 10px;

    .user-box-num {
      position: absolute;
      top: 10px;
      left: 40px;
    }

    &.active {
      background: #fafafa;
    }

    .avatar {
      width: 42px;
      height: 42px;
      border-radius: 50%;
    }

    .badge {
      background-color: #f34d37;
      border-radius: 10px;
      color: #fff;
      display: inline-block;
      font-size: 12px;
      height: 18px;
      line-height: 18px;
      padding: 0 6px;
      text-align: center;
      white-space: nowrap;
      border: 1px solid #fff;
    }
  }
}

.style-list::-webkit-scrollbar {
  display: none;
}

.style-list {
  width: 270px;
  height: 800px;
  background: #ebe9e7;
  overflow-y: scroll;
  overflow-x: hidden;

  .search-box {
    height: 65px;
    padding: 13px 15px;
    border-bottom: 1px solid #e1e2e6;

    .search-content {
      width: 240px;
      height: 40px;
      background: #fafafa;
      border-radius: 20px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      position: sticky;
      top: 10px;
      left: 0px;
      z-index: 1;

      .input {
        border: none;
        background: #fafafa;
        outline: none;
        flex: 1;
      }
    }
  }

  .style-item {
    position: relative;
    display: flex;
    align-items: center;
    height: 66px;
    padding: 10px;

    .user-box-num {
      position: absolute;
      top: 10px;
      left: 40px;
    }

    &.active {
      background: #c6c4c4;
    }

    .style-img {
      width: 42px;
      height: 42px;
      border-radius: 2px;
    }

    .badge {
      background-color: #f34d37;
      border-radius: 10px;
      color: #fff;
      display: inline-block;
      font-size: 12px;
      height: 18px;
      line-height: 18px;
      padding: 0 6px;
      text-align: center;
      white-space: nowrap;
      border: 1px solid #fff;
    }
  }
}

.chat-list {
  width: 627px;

  .chat-title {
    background-color: #fafafa;
    height: 65px;
    padding: 0 16px;
    line-height: 65px;
    font-weight: bold;
    font-size: 16px;
    color: #333;
  }

  .chat-content {
    height: 535px;
    overflow-y: scroll;
    overflow-x: hidden;
    background: #f5f5f5;
    padding: 25px;

    .chat-item {
      display: flex;
      margin-bottom: 20px;
      // align-items: center;
      .chat-item-action {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .action-item-box {
          padding: 10px;
          .action-item {
            text-align: center;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            cursor: pointer;
          }
        }
      }
      .avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }

      .message-box {
        border-radius: 5px;
        padding: 10px;
        .quote-message-box {
          padding-bottom: 10px;
          cursor: pointer;
          .message {
            color: #999999;
          }
        }
        .message {
          max-width: 360px;
          padding: 5px;
          color: #262626;
        }

        .file-box {
          max-width: 360px;
          .file-img {
            width: 40px;
            height: 40px;
          }
        }
      }
    }

    .chat-item-left {
      justify-content: flex-start;
      .message-box {
        margin-left: 10px;
        background: #ffffff;
        .quote-message-box {
          border-bottom: 1px solid #dddddd;
        }
      }
    }

    .chat-item-right {
      justify-content: flex-end;
      .message-box {
        margin-right: 10px;
        background: #e6e6e6;
        .quote-message-box {
          border-bottom: 1px solid #f5f5f5;
        }
      }
    }
  }

  .chat-input {
    height: calc(100% - 50px);
    width: 100%;
    background: #ffffff;

    .chat-input-textarea {
      font-style: normal;
      width: 100%;
      border: none;
      padding: 10px;
      outline: none;
      resize: none;
      height: 100%;
    }
  }

  .submit {
    width: 96px;
    height: 35px;
    background: #fa3d5a;
    border-radius: 5px;
    color: #ffffff;
    padding: 0;
    margin: 0;
    border: none;
    position: absolute;
    right: 20px;
    bottom: 10px;
  }

  .chat-content::-webkit-scrollbar {
    display: none;
  }

  .submit-box {
    height: 150px;
    padding: 0 10px 17px;
  }
  .resizer {
    height: 6px;
    background-color: transparent;
    cursor: ns-resize;
    position: relative;
    transition: background-color 0.2s;
  }

  .resizer:hover {
    background-color: #f0f0f0;
  }

  .resizer.resizing {
    background-color: #e0e0e0;
  }
  .resizer-dot {
    width: 30px;
    height: 2px;
    background-color: #cbd5e1;
    border-radius: 1px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .resizer.resizing .resizer-dot {
    background-color: #94a3b8;
  }

  .icon-emoji {
    width: 23px;
    height: 23px;
    background-image: url(../assets/images/chat/icon-emoji.png);
    background-repeat: no-repeat;
    background-size: cover;
    border: none;
    position: relative;
  }

  button {
    background: transparent;
  }

  .emoji-invoker {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s;
    padding: 0;
    background: transparent;
    border: 0;
  }

  .emoji-invoker:hover {
    transform: scale(1.1);
  }

  // .emoji-invoker > svg {
  //   fill: #b1c6d0;
  // }

  .emoji-picker {
    position: absolute;
    z-index: 1;
    font-family: Montserrat;
    border: 1px solid #ccc;
    width: 30rem;
    height: 20rem;
    overflow: scroll;
    padding: 1rem;
    box-sizing: border-box;
    border-radius: 0.5rem;
    background: #fff;
    box-shadow: 1px 1px 8px #c7dbe6;
    bottom: 150px !important;
    right: 10px !important;
  }

  .emoji-picker__search {
    display: none;
  }

  .emoji-picker__search > input {
    flex: 1;
    border-radius: 10rem;
    border: 1px solid #ccc;
    padding: 0.5rem 1rem;
    outline: none;
  }

  .emoji-picker h5 {
    margin-bottom: 0;
    color: #b1b1b1;
    text-transform: uppercase;
    font-size: 0.8rem;
    cursor: default;
  }

  .emoji-picker .emojis {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .emoji-picker .emojis:after {
    content: "";
    flex: auto;
  }

  .emoji-picker .emojis span {
    padding: 0.2rem;
    cursor: pointer;
    border-radius: 5px;
  }

  .emoji-picker .emojis span:hover {
    background: #ececec;
    cursor: pointer;
  }
}

.message-tabs {
  width: 200px;
  height: 800px;
  background: #ebe9e7;

  .search-box {
    width: 200px;
    height: 65px;
    padding: 13px 15px;
    border-bottom: 1px solid #e1e2e6;

    .search-content {
      width: 180px;
      height: 40px;
      background: #fafafa;
      border-radius: 20px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      position: sticky;
      top: 10px;
      left: 0px;
      z-index: 1;

      .input {
        border: none;
        background: #fafafa;
        outline: none;
        width: 80%;
      }
    }
  }

  .message-tab {
    width: 200px;
    height: 45px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333333;

    .badge {
      background-color: #f34d37;
      border-radius: 10px;
      color: #fff;
      display: inline-block;
      font-size: 12px;
      height: 18px;
      line-height: 18px;
      padding: 0 6px;
      text-align: center;
      white-space: nowrap;
      border: 1px solid #fff;
    }

    .icon {
      width: 22px;
      height: 22px;
      margin-right: 10px;
    }

    &.active {
      background: #fafafa;
    }
  }
}

.message-list {
  flex: 1;

  .top {
    border-top-right-radius: 10px;
    height: 65px;
    background: #fafafa;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 50px 0 15px;

    .left {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title {
        font-weight: bold;
        font-size: 16px;
        color: #1a1a1a;
      }
    }

    .status-tabs {
      margin-left: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 90px;
      height: 30px;
      background: #ecedee;
      border-radius: 5px;
      padding: 0 2px;

      .tab {
        width: 50%;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
        color: #808080;

        &.active {
          width: 43px;
          height: 26px;
          line-height: 26px;
          background: #ffffff;
          border-radius: 5px 5px 5px 5px;
          font-size: 12px;
          color: #000000;
        }
      }
    }

    .set-all-read {
      width: 100px;
      height: 30px;
      background: #fafafa;
      border-radius: 5px 5px 5px 5px;
      border: 1px solid #e1e2e6;
      font-size: 12px;
      color: #808080;
      cursor: pointer;
    }

    .close {
      width: 24px;
      height: 24px;
      cursor: pointer;
      position: absolute;
      top: 15px;
      right: 15px;
    }
  }

  .messgae-content {
    height: 685px;
    overflow-y: scroll;
    overflow-x: hidden;
    background: #f5f5f5;
    padding: 25px;

    .message-item {
      margin-bottom: 10px;
      background: #ffffff;
      border-radius: 10px;
      display: flex;
      padding: 15px;
      position: relative;

      .icon {
        width: 20px;
        height: 20px;
      }

      .title-box {
        display: flex;
        align-items: center;

        .title {
          font-size: 16px;
          color: #000000;
        }

        .time {
          font-size: 14px;
          color: #999999;
          margin-left: 10px;
        }
      }

      .content-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;

        .content {
          font-size: 14px;
          color: #999999;
          width: 85%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .view {
          font-size: 14px;
          color: #999999;
          cursor: pointer;
        }
      }

      .action {
        display: none;

        position: absolute;
        right: 25px;
        top: 8px;

        .read,
        .delete {
          width: 40px;
          height: 25px;
          line-height: 25px;
          background: #f2f2f3;
          border-radius: 5px;
          text-align: center;
          margin-left: 10px;
          font-size: 12px;
          color: #b3b3b3;
          cursor: pointer;
        }
      }

      .red-dot {
        width: 8px;
        height: 8px;
        background: #ff2b00;
        border-radius: 50%;
        position: absolute;
        right: 5px;
        top: 5px;
      }
    }

    .message-item:hover {
      box-shadow: 0px 0px 4px 0px #4d4b4b;

      .action {
        display: flex;
        align-items: center;
      }
    }

    .message-loading {
      text-align: center;
      color: #999999;
      font-size: 13px;
      padding: 15px 0;
    }
  }
}

.is_read {
  font-size: 12px;
  color: #999999;
}

.is_no_read {
  font-size: 12px;
  color: #35b3ee;
}
.fabric_accessory_info {
  cursor: pointer;
  height: 150px;
  width: 120px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .image {
    border: 1px solid #ebedf2;
    height: 120px;
    width: 120px;
    object-fit: cover;
    border-radius: 10px 10px 0 0;
  }
  .name {
    font-size: 14px;
    color: #333333;
    font-weight: bold;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
    padding: 0 5px;
  }
}
.design_info {
  display: flex;
  flex-wrap: nowrap;
  flex: 0 1 48%;
  height: 120px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #ebedf2;
  cursor: pointer;

  .left {
    width: 120px;
    height: 100%;
    .image {
      border: 1px solid #ebedf2;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 10px 0 0 10px;
    }
  }
  .right {
    margin: 0 20px;
    text-align: left;
    flex: 1;
    .name-wrap {
      height: 53px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ebedf2;
      .name {
        font-size: 16px;
        color: #333333;
        font-weight: bold;
      }
      .status {
        width: 70px;
        height: 25px;
        line-height: 25px;
        border-radius: 5px 0px 5px 0px;
        text-align: center;
        font-family: "Microsoft YaHei";
        &.draft {
          color: #30c6d0;
          border: 1px solid #30c6d0;
        }
        &.bargain {
          color: #ff9000;
          border: 1px solid #ff9000;
        }
        &.confirm_design {
          color: #e72c28;
          border: 1px solid #e72c28;
        }
      }
    }

    .style_no,
    .category,
    .desc {
      margin: 6px 0;
      color: #707070;
      font-size: 14px;
    }
    .desc {
      height: 40px;
      overflow-y: hidden;
    }

    span {
      color: #4d4d4d;
      font-size: 14px;
    }

    .time {
      margin: 5px 0;
      font-size: 12px;
      color: #808080;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}
.quote-box {
  background: #f0f2f5;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 400;
  color: #666666;
  padding: 10px;
  max-width: 400px;
}

/* 语音消息气泡（展示与播放） */
.voice-msg-box {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  padding: 8px 14px;
  border-radius: 12px;
  cursor: pointer;
  background: #ffffff;
}
.chat-item-right .voice-msg-box {
  background: #95ec69;
}
.voice-play-icon {
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  margin-right: 8px;
}
.voice-playing-tip {
  font-size: 12px;
  color: #333;
  margin-right: 8px;
}
.voice-duration {
  font-size: 13px;
  color: #333;
}
</style>
